<script>
/**
 * 【利用者による編集が必要】
 * センシティブ情報(ログイン期間中のみ取得できる情報)を格納するミックスイン
 * 1. センシティブ情報管理機能を使用しない場合(デフォルト)
 * ・「this.miiafwCognitolibs_updateSensitiveInfo()」をコールする。(引数は空のオブジェクト({}))
 * ・resolve()を実行する。
 * 2. センシティブ情報管理機能を使用する場合
 *   1-1 データソースからセンシティブ情報取得成功時
 *   ・「this.miiafwCognitolibs_updateSensitiveInfo()」をコールする。(引数は取得したセンシティブ情報)
 *   ・resolve()を実行する。
 *   1-2 データソースからセンシティブ情報取得失敗時、プロファイル表示機能を使用しない場合
 *   ・「this.miiafwCognitolibs_updateSensitiveInfo()」をコールする。(引数は空のオブジェクト({}))
 *   ・reject({ message: [エラーメッセージ] })を実行する。
 *   1-3 各機能からセンシティブ情報を取得する場合は本ミックスインをインポートし、sensitiveInfo_getSensitiveInfoFromStore()を実行する。
 */
import MiiaFwCognitoMixin from '@/components/miiafw/mixin/MiiaFwCognitoMixin.vue'

export default {
  name: 'SensitiveInfoMixin',
  mixins: [MiiaFwCognitoMixin],
  methods: {
    // センシティブ情報を設定する。
    sensitiveInfo_get () {
      return new Promise((resolve, reject) => {
        // 【利用者による編集が必要】
        this.miiafwCognitolibs_updateSensitiveInfo({})
        resolve()
      })
    },
    // センシティブ情報を取得する。
    sensitiveInfo_getSensitiveInfoFromStore () {
      return new Promise((resolve, reject) => {
        if (this.$store.getters['miiaFwStore/sensitiveInfo'] !== undefined) {
          resolve(this.$store.getters['miiaFwStore/sensitiveInfo'])
        } else {
          const unwatch = this.$store.watch(
            (state, getters) => {
              return state.miiaFwStore.cognitoAuth.sensitiveInfo
            },
            (newVal, oldVal) => {
              if (oldVal === undefined) {
                resolve(this.$store.getters['miiaFwStore/sensitiveInfo'])
              } else {
                // 処理なし
              }
              unwatch() // 監視を解除
              clearTimeout(timerObj)
            }
          )
          // 5秒以内にトークンからセンシティブ情報を取得できなかった場合はタイムアウト
          const timerObj = setTimeout(() => {
            unwatch()
            reject({ message: 'センシティブ情報の取得に失敗しました。' })
          }, 5000)
        }
      })
    }
  }
}
</script>
